import { getByPath } from "@json-render/core";

export function snapshotFeedState(
  viewState: Record<string, unknown> | undefined,
  feeds: Readonly<Record<string, { readonly value: unknown }>>,
): Record<string, unknown> {
  const entries = Object.entries(feeds);
  return {
    ...viewState,
    ...Object.fromEntries(entries.map(([key, feed]) => [key, feed.value])),
    $data: Object.fromEntries(
      entries.map(([key]) => [key, { loading: false, error: null }]),
    ),
  };
}

export function stateAt(
  state: Record<string, unknown>,
  pointer: string,
): unknown {
  return getByPath(state, pointer);
}
